var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 118,
    fill: "none",
    viewBox: "0 0 132 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 118,
    fill: "#F2F6FB",
    rx: 6.028,
    transform: "matrix(-1 0 0 1 132 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80.599,
    height: 4.853,
    fill: "#E1E5F0",
    rx: 1.959,
    transform: "matrix(-1 0 0 1 106.147 87.662)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F95B45",
    fillRule: "evenodd",
    d: "M66 19c-14.912 0-27 12.088-27 27s12.088 27 27 27 27-12.088 27-27c0-7.16-2.845-14.028-7.908-19.092C80.028 21.845 73.16 19 66 19zm0 40.5c-1.492 0-2.7-1.209-2.7-2.7s1.208-2.7 2.7-2.7c1.49 0 2.7 1.209 2.7 2.7s-1.21 2.7-2.7 2.7zm2.7-10.8c0 1.491-1.21 2.7-2.7 2.7-1.492 0-2.7-1.209-2.7-2.7V35.2c0-1.491 1.208-2.7 2.7-2.7 1.49 0 2.7 1.209 2.7 2.7v13.5z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationFailure);
export default __webpack_public_path__ + "static/media/integration-failure.c45c9e00f51e6493d0e1e57661226e81.svg";
export { ForwardRef as ReactComponent };